export default {
	showNotification({ commit }) {
		commit('SET_SHOWNOTIFICATION_TRUE');
	},

	hideNotification({ commit }) {
		commit('SET_SHOWNOTIFICATION_FALSE');
	}
};
